import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-51712754"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "wrapper ml50 pl25 pb25 pr20 pt10"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "title"
}, "账户安全", -1));
const _hoisted_3 = {
  class: "mb40 mt10 flex"
};
const _hoisted_4 = ["onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.data.comps, (item, index) => {
    return _openBlock(), _createElementBlock("p", {
      onClick: () => $setup.changeTabs(index),
      class: _normalizeClass(['tab pointer', index == $setup.data.tabsIndex && 'active']),
      key: index
    }, _toDisplayString(item.label), 11, _hoisted_4);
  }), 128))]), (_openBlock(), _createBlock(_resolveDynamicComponent($setup.data.comps[$setup.data.tabsIndex].name)))]);
}